import { useRequest } from './chunk-SNCLEEAV.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';

// src/listen/query-hooks/home.ts
var homeQuery = graphql(`
  query ListenHome @cached {
    audios {
      id
      name
      source
      thumbnailUrl
      artistName
      audio_tags {
        tag_id
      }
    }
    tags(where: { site: { _eq: "listen" } }) {
      id
      name
    }
    playlist(
      where: { site: { _eq: "listen" } }
      order_by: { createdAt: desc }
    ) {
      id
      title
      slug
    }
  }
`);
var transformAudio = (audio) => {
  var _a;
  return {
    id: audio.id,
    name: audio.name,
    source: audio.source,
    thumbnailUrl: audio.thumbnailUrl || "",
    artistName: audio.artistName,
    audio_tags: (_a = audio.audio_tags) != null ? _a : []
  };
};
var useLoadHome = () => {
  var _a, _b;
  const { isSignedIn, getAccessToken } = useAuthContext();
  const { data, isLoading, error } = useRequest({
    queryKey: ["listen-home", isSignedIn],
    getAccessToken: isSignedIn ? getAccessToken : void 0,
    document: homeQuery
  });
  return {
    audios: data ? data.audios.map(transformAudio) : [],
    feelings: (_a = data == null ? void 0 : data.tags) != null ? _a : [],
    playlists: (_b = data == null ? void 0 : data.playlist) != null ? _b : [],
    isLoading,
    error
  };
};

export { useLoadHome };
//# sourceMappingURL=chunk-5LW5YMR5.mjs.map
//# sourceMappingURL=chunk-5LW5YMR5.mjs.map